var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// Mock data for tags
const mockTags = [
    {
        id: 1,
        name: 'Important',
        color: '#FF0000',
        createdBy: 1,
        createdAt: '2024-01-01T00:00:00Z',
        updatedAt: '2024-01-01T00:00:00Z',
    },
    {
        id: 2,
        name: 'Todo',
        color: '#00FF00',
        createdBy: 1,
        createdAt: '2024-01-01T00:00:00Z',
        updatedAt: '2024-01-01T00:00:00Z',
    },
];
// Mock data for notes
const mockNotes = [
    {
        id: 1,
        name: 'Test Note 1',
        text: 'This is a test note',
        tags: [mockTags[0]],
        linkedNotes: [],
        createdBy: 1,
        createdByUsername: 'testuser',
        createdAt: '2024-01-01T00:00:00Z',
        updatedAt: '2024-01-01T00:00:00Z',
    },
    {
        id: 2,
        name: 'Test Note 2',
        text: 'Another test note',
        tags: [mockTags[1]],
        linkedNotes: [1],
        createdBy: 1,
        createdByUsername: 'testuser',
        createdAt: '2024-01-02T00:00:00Z',
        updatedAt: '2024-01-02T00:00:00Z',
    },
];
export const mockNoteApi = {
    list: (params) => __awaiter(void 0, void 0, void 0, function* () {
        let filtered = [...mockNotes];
        if (params === null || params === void 0 ? void 0 : params.created_by) {
            filtered = filtered.filter((n) => n.createdBy === params.created_by);
        }
        if (params === null || params === void 0 ? void 0 : params.tags) {
            filtered = filtered.filter((n) => n.tags.some((t) => t.id === params.tags));
        }
        if (params === null || params === void 0 ? void 0 : params.search) {
            const searchLower = params.search.toLowerCase();
            filtered = filtered.filter((n) => n.name.toLowerCase().includes(searchLower) || n.text.toLowerCase().includes(searchLower));
        }
        return Promise.resolve(filtered);
    }),
    get: (id) => __awaiter(void 0, void 0, void 0, function* () {
        const note = mockNotes.find((n) => n.id === id);
        if (!note) {
            throw new Error('Note not found');
        }
        return Promise.resolve(note);
    }),
    create: (note) => __awaiter(void 0, void 0, void 0, function* () {
        const newNote = {
            id: mockNotes.length + 1,
            name: note.name,
            text: note.text || '',
            tags: mockTags.filter((t) => { var _a; return (_a = note.tagIds) === null || _a === void 0 ? void 0 : _a.includes(t.id); }) || [],
            linkedNotes: note.linkedNoteIds || [],
            createdBy: 1,
            createdByUsername: 'testuser',
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString(),
        };
        mockNotes.push(newNote);
        return Promise.resolve(newNote);
    }),
    update: (id, note) => __awaiter(void 0, void 0, void 0, function* () {
        const index = mockNotes.findIndex((n) => n.id === id);
        if (index === -1) {
            throw new Error('Note not found');
        }
        const updatedNote = Object.assign(Object.assign(Object.assign({}, mockNotes[index]), note), { tags: note.tagIds
                ? mockTags.filter((t) => { var _a; return (_a = note.tagIds) === null || _a === void 0 ? void 0 : _a.includes(t.id); })
                : mockNotes[index].tags, linkedNotes: note.linkedNoteIds || mockNotes[index].linkedNotes, updatedAt: new Date().toISOString() });
        mockNotes[index] = updatedNote;
        return Promise.resolve(updatedNote);
    }),
    delete: (id) => __awaiter(void 0, void 0, void 0, function* () {
        const index = mockNotes.findIndex((n) => n.id === id);
        if (index === -1) {
            throw new Error('Note not found');
        }
        mockNotes.splice(index, 1);
        return Promise.resolve();
    }),
    linkNote: (id, linkedNoteId) => __awaiter(void 0, void 0, void 0, function* () {
        const note = mockNotes.find((n) => n.id === id);
        if (!note) {
            throw new Error('Note not found');
        }
        if (!note.linkedNotes) {
            note.linkedNotes = [];
        }
        if (!note.linkedNotes.includes(linkedNoteId)) {
            note.linkedNotes.push(linkedNoteId);
        }
        return Promise.resolve({ ok: true, message: 'Note linked successfully' });
    }),
    unlinkNote: (id, linkedNoteId) => __awaiter(void 0, void 0, void 0, function* () {
        const note = mockNotes.find((n) => n.id === id);
        if (!note) {
            throw new Error('Note not found');
        }
        if (note.linkedNotes) {
            note.linkedNotes = note.linkedNotes.filter((lid) => lid !== linkedNoteId);
        }
        return Promise.resolve({ ok: true, message: 'Note unlinked successfully' });
    }),
};
export const mockTagApi = {
    list: (params) => __awaiter(void 0, void 0, void 0, function* () {
        let filtered = [...mockTags];
        if (params === null || params === void 0 ? void 0 : params.name) {
            filtered = filtered.filter((t) => t.name.toLowerCase().includes(params.name.toLowerCase()));
        }
        if (params === null || params === void 0 ? void 0 : params.created_by) {
            filtered = filtered.filter((t) => t.createdBy === params.created_by);
        }
        return Promise.resolve(filtered);
    }),
    get: (id) => __awaiter(void 0, void 0, void 0, function* () {
        const tag = mockTags.find((t) => t.id === id);
        if (!tag) {
            throw new Error('Tag not found');
        }
        return Promise.resolve(tag);
    }),
    create: (tag) => __awaiter(void 0, void 0, void 0, function* () {
        const newTag = {
            id: mockTags.length + 1,
            name: tag.name,
            color: tag.color || '#000000',
            createdBy: 1,
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString(),
        };
        mockTags.push(newTag);
        return Promise.resolve(newTag);
    }),
    update: (id, tag) => __awaiter(void 0, void 0, void 0, function* () {
        const index = mockTags.findIndex((t) => t.id === id);
        if (index === -1) {
            throw new Error('Tag not found');
        }
        const updatedTag = Object.assign(Object.assign(Object.assign({}, mockTags[index]), tag), { updatedAt: new Date().toISOString() });
        mockTags[index] = updatedTag;
        return Promise.resolve(updatedTag);
    }),
    delete: (id) => __awaiter(void 0, void 0, void 0, function* () {
        const index = mockTags.findIndex((t) => t.id === id);
        if (index === -1) {
            throw new Error('Tag not found');
        }
        mockTags.splice(index, 1);
        return Promise.resolve();
    }),
};
